import React from 'react';
import SarasButton from '../../../../../library/input/buttons/button/SarasButton';
import ImportShorthand from "../../../../io/components/ImportShorthand";

const DocSearchImportContainer = (props) => {
    const { importTpl } = props;

    const [open,setOpen] = React.useState(false);

    const renderImportPopup = () => {
        if(open)
        {
            // console.log("Import DocSearchImport", importTpl)
            return(
                <ImportShorthand importTpl={importTpl} onPopupClose={onPopupClose}  />
            )
        }
    }

    const onImportBtnClick = () => {
        setOpen(true);
    }

    const onPopupClose = () => {
        setOpen(false);
    }

    return (
        <>
            <SarasButton className="" 
                text="Import Data" 
                starIcon="import"
                tooltip="Import Data" 
                onClick={onImportBtnClick} >
            </SarasButton>
            {renderImportPopup()}
        </>
    )
}

export default DocSearchImportContainer;
